<template>
  <div v-show="hayDatosSesion">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-sm table-striped table-hover">
            <thead>
              <tr>
                <th class="position-sticky bg-white text-right">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="vista-simplificada" v-model="esVistaSimplificada">
                    <label class="custom-control-label small" for="vista-simplificada" title="Vista simplificada" v-tooltip>
                      <i class="fa-solid fa-magnifying-glass-chart align-bottom"></i>
                    </label>
                  </div>
                </th>
                <th v-for="(a, index) in meses" :key="index" scope="col" class="text-capitalize text-center" :class="{ 'bg-primary text-light': hayAltMode && columnaActiva == index + 1, 'pointer-events-none': !editable }" :tabindex="hayAltMode ? index + 1 : 1" @keyup.enter="switchFocus(index + 1)" @click="switchFocus(index + 1)" role="button">
                  <div>{{ getMonth(a.mes) }}</div>
                </th>
              </tr>
              <tr class="table-light collapse" data-collapse="calculos">
                <td class="text-right position-sticky">Dies hàbils</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">{{ a.diasDisponibles ? a.diasDisponibles : "-" }}</td>
              </tr>
              <tr class="table-light collapse" data-collapse="calculos">
                <td class="text-right position-sticky">Dies personals</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  <form @submit.prevent="cambiarFestivos(a)">
                    <input-debounce type="number" min="0" :max="maxFestivo" class="d-inline form-control-plaintext p-0 text-right input-number-2" v-model.number="a.diasFestivos" @debouncedInput="submitForm" :disabled="!editable" />
                    <input type="submit" hidden />
                  </form>
                </td>
              </tr>
              <tr class="table-light collapse" data-collapse="calculos">
                <td class="text-right position-sticky">Dedicació possible</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  {{ a.dedicacionPosible ? a.dedicacionPosible : "-" }}
                </td>
              </tr>
              <tr class="table-light collapse" data-collapse="calculos">
                <td class="text-right position-sticky">Hores lliures</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered" :class="{ 'text-danger': a.horasLibres < 0 }">
                  {{ a.horasLibres }}
                </td>
              </tr>
              <tr class="table-light desplegable-inferior" data-toggle="collapse" data-target="[data-collapse='calculos']" role="button">
                <th class="text-right position-sticky" scope="row"><i class="fa-solid fa-caret-right"></i> Dedicació</th>
                <th v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  <template v-if="a.dedicacionProgramadaTotal">
                    <span v-if="isFinite(a.dedicacionProgramadaTotalPc)">
                      <span v-show="!esVistaSimplificada">{{ a.dedicacionProgramadaTotal }} (</span>
                      <span :class="{ 'text-danger': a.horasLibres < 0 }">{{ a.dedicacionProgramadaTotalPc }}%</span>
                      <span v-show="!esVistaSimplificada">)</span>
                    </span>
                    <span v-else>{{ a.dedicacionProgramadaTotal }}</span>
                  </template>
                  <template v-else>-</template>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="!esVistaSimplificada" class="table-light">
                <td scope="row" class="position-sticky text-right" :title="`Si la xifra es calculada: mitjana segons els últims ${meses.length} mesos`" v-tooltip>Estructural</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  <form v-if="horasIndicadas[`${a.anyo}${a.mes}`]" @submit.prevent="cambiarHorasGrupo('estructural', a)">
                    <input-debounce type="number" min="0" class="d-inline form-control-plaintext p-0 text-right input-number-2" v-model.number="horasIndicadas[`${a.anyo}${a.mes}`].estructural" :placeholder="a.noIndicadaEstructural ? a.estructural : ''" @debouncedInput="submitForm" :disabled="!editable" />
                    <input type="submit" hidden />
                  </form>
                </td>
              </tr>
              <tr v-show="!esVistaSimplificada" class="table-light">
                <td scope="row" class="position-sticky text-right" :title="`Si la xifra es calculada: mitjana segons els últims ${meses.length} mesos`" v-tooltip>Comercial</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  <form v-if="horasIndicadas[`${a.anyo}${a.mes}`]" @submit.prevent="cambiarHorasGrupo('comercial', a)">
                    <input-debounce type="number" min="0" class="d-inline form-control-plaintext p-0 text-right input-number-2" v-model.number="horasIndicadas[`${a.anyo}${a.mes}`].comercial" :placeholder="a.noIndicadaComercial ? a.comercial : ''" @debouncedInput="submitForm" :disabled="!editable" />
                    <input type="submit" hidden />
                  </form>
                </td>
              </tr>
              <tr class="table-light">
                <th scope="row" class="position-sticky text-right">Oficina tècnica</th>
                <th v-for="(a, index) in meses" :key="index" scope="col" class="text-center">
                  <span v-if="a.dedicacionProgramada">{{ a.dedicacionProgramada }} <span v-if="isFinite(a.dedicacionProgramadaPc)">({{ a.dedicacionProgramadaPc }}%)</span></span>
                  <span v-else>-</span>
                </th>
              </tr>
            </tbody>
            <draggable class="border-top-0" tag="tbody" :list="proyectosUnicosOrdenados" ghost-class="ghost" @start="ordenando = true" @end="ordenando = false" handle=".draggable-handler" :disabled="loading.orden">
              <tr v-for="(a, index) in proyectosUnicosOrdenados" :key="index">
                <td scope="row" class="position-sticky table-light text-right d-flex align-items-center justify-content-between">
                  <button class="btn btn-outline-secondary draggable-handler btn-sm mr-3" title="Canviar ordre" ref="ordenables" :class="{ disabled: loading.orden, invisible: proyectosUnicosOrdenados.length == 1 || !editable }" :disabled="loading.orden" v-tooltip><i class="fa-solid fa-up-down-left-right"></i></button>
                  <celda-proyecto :proyecto="filtrarProyecto(a, 'titol')" :cliente="filtrarProyecto(a, 'cliente')" :totalProyecto="filtrarPrevision(a, 'proyectos')" :totalFila="extraerTotalProyecto(a)" />
                </td>
                <td v-for="(b, bindex) in meses" :key="bindex" scope="col" class="table-bordered align-middle" :class="{ 'table-primary': hayAltMode && columnaActiva == bindex + 1, 'table-danger': hasLimitOverpassed(a, b.anyo, b.mes + 1) }" :title="hasLimitOverpassed(a, b.anyo, b.mes + 1) ? 'La data límit d\'aquest projecte és el ' + getLimitDate(a) : ''" v-tooltip>
                  <div v-if="proyectosOrganizados[a][b.anyo] && proyectosOrganizados[a][b.anyo][b.mes + 1]" class="d-flex justify-content-center">
                    <form class="text-nowrap" @submit.prevent="cambiarHoras(proyectosOrganizados[a][b.anyo][b.mes + 1])">
                      <input-debounce type="number" min="0" :max="maxInt" class="d-inline form-control-plaintext p-0 text-right input-number-2" v-model.number="proyectosOrganizados[a][b.anyo][b.mes + 1].hores_previstes" @debouncedInput="submitForm" :tabindex="hayAltMode ? bindex + 1 : 1" @focus="focus" :disabled="!editable" />
                      <span v-show="!esVistaSimplificada">
                        <span v-if="proyectosOrganizados[a][b.anyo][b.mes + 1].hores_previstes && isFinite(calcularPcPlan(b.mes, b.anyo, proyectosOrganizados[a][b.anyo][b.mes + 1].hores_previstes))">
                          (<span :class="{ 'text-danger': proyectosOrganizados[a][b.anyo][b.mes + 1].hores_previstes < 0 }">{{ calcularPcPlan(b.mes, b.anyo, proyectosOrganizados[a][b.anyo][b.mes + 1].hores_previstes) }}%</span>)
                        </span>
                        <span v-else class="invisible">
                          (XX%)
                        </span>
                      </span>
                      <input type="submit" hidden />
                    </form>
                  </div>
                  <div v-else class="d-flex justify-content-center">
                    <form class="text-nowrap" @submit.prevent="cambiarHoras({ any: [b.anyo][0], mes: [b.mes + 1][0], hores_previstes: posiblesPrevistas[a][b.anyo][b.mes + 1], id_projecte: proyectosUnicosOrdenados[index] })">
                      <input-debounce type="number" min="0" :max="maxInt" class="d-inline form-control-plaintext p-0 text-right input-number-2" v-model.number="posiblesPrevistas[a][b.anyo][b.mes + 1]" @debouncedInput="submitForm" :tabindex="hayAltMode ? bindex + 1 : 1" @focus="focus" :disabled="!editable" />
                      <span v-show="!esVistaSimplificada && isFinite(calcularPcPlan(b.mes, b.anyo, posiblesPrevistas[a][b.anyo][b.mes + 1]))">
                        <span v-if="posiblesPrevistas[a][b.anyo][b.mes + 1]">
                          (<span :class="{ 'text-danger': posiblesPrevistas[a][b.anyo][b.mes + 1] < 0 }">{{ calcularPcPlan(b.mes, b.anyo, posiblesPrevistas[a][b.anyo][b.mes + 1]) }}%</span>)
                        </span>
                        <span v-else class="invisible">
                          (XX%)
                        </span>
                      </span>
                      <input type="submit" hidden />
                    </form>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </div>
    <div v-if="editable" class="row mt-3">
      <div class="col-12 col-md-6 col-lg-4 mx-auto">
        <label for="proyecto">Afegir projecte</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-archive" title="Projecte" v-tooltip></i></div>
          </div>
          <select class="form-control" id="proyecto" v-model="proyecto" required @change="anyadirProyecto">
            <option v-for="(proyecto, index) in proyectosAnyadibles" :key="index">{{ getProyectoValue(proyecto.titol, proyecto.cliente) }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CeldaProyecto from './CeldaProyecto.vue';
import InputDebounce from './InputDebounce.vue';
import draggable from "vuedraggable";

export default {
  name: "TablaPlaDedicacio",
  inject: ["locale", "getMonth", "horasDiarias", "calcularDiasHabiles"],
  props: {
    editable: Boolean,
    trabajadorEscogido: {
      type: Number,
      required: true,
    },
  },
  components: {
    CeldaProyecto,
    InputDebounce,
    draggable,
  },
  data() {
    return {
      loading: {
        orden: false,
      },
      ordenando: false,
      rows: [],
      proyectos: [],
      festivosPersonales: [],
      festivosEmpresa: [],
      maxInt: 255,
      maxFestivo: 31,
      hayAltMode: false,
      columnaActiva: null,
      proyecto: "",
      calculados: {
        estructural: 0,
        comercial: 0,
        facturable: 0,
      },
      previsiones: {
        proyectos: [],
        anyadidos: [],
      },
      esVistaSimplificada: false,
      jornada: null,
      hayDatosSesion: null,
      usuarioRol: null,
      horasAnyadidos: [],
      posiblesPrevistas: {},
      OKmessage: "Canvis desats.",
      totalMeses: 12,
      horasIndicadas: [],
    };
  },
  computed: {
    calculadosTotal() {
      return Object.values(this.calculados).reduce((a, b) => a + parseFloat(b), 0);
    },
    minFecha() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      return tomorrow.toISOString().split("T")[0];
    },
    minMonth() {
      return `${new Date().getUTCFullYear()}-${String(new Date().getUTCMonth() + 2).padStart(2, "0")}`;
    },
    meses() {
      const meses = [];
      const pcEstructural = 0.2;

      for (var i = 0; i < this.totalMeses; i++) {
        const fecha = new Date(new Date().getFullYear(), new Date().getMonth() + i, 1);
        const horaIndicada = this.horasIndicadas[`${fecha.getFullYear()}${fecha.getMonth()}`];
        const noIndicadaEstructural = horaIndicada?.estructural === "" || horaIndicada?.estructural == null;
        const noIndicadaComercial = horaIndicada?.comercial === "" || horaIndicada?.comercial == null;
        const diasFestivos = this.festivosPersonales.find((a) => a.mes == fecha.getMonth() + 1 && a.any == fecha.getFullYear())?.dies;
        const diasEmpresa = this.festivosEmpresa.filter((a) => new Date(a.festiu_empresa).getMonth() == fecha.getMonth() && new Date(a.festiu_empresa).getFullYear() == fecha.getFullYear());
        const dedicacionProgramada = Math.round(
          (this.rows.filter((a) => a.any == fecha.getFullYear() && a.mes == fecha.getMonth() + 1).reduce((a, b) => a + parseInt(b.hores_previstes?.length ?? b.hores_previstes ?? 0), 0) ?? 0)
          +
          (this.horasAnyadidos.filter((a) => a.mes.anyo == fecha.getFullYear() && a.mes.mes == fecha.getMonth()).reduce((a, b) => a + parseInt(b.horasPrevistas ?? 0), 0) ?? 0)
        );
        const diasDisponibles = this.calcularDiasHabiles(new Date(fecha.getTime()), new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0)) - diasEmpresa.length;
        const dedicacionPosible = Math.round((diasDisponibles - (diasFestivos ?? 0)) * ((this.horasDiarias * parseFloat(this.jornada)) / 100));
        const estructural = noIndicadaEstructural ? Math.round((this.calculados.estructural / this.calculadosTotal) * dedicacionPosible) : horaIndicada.estructural;
        const comercial = noIndicadaComercial ? Math.round((this.calculados.comercial / this.calculadosTotal) * dedicacionPosible) : horaIndicada.comercial;
        const dedicacionProgramadaTotal = Math.round(dedicacionProgramada + estructural + comercial);
        const horasLibres = dedicacionPosible - dedicacionProgramadaTotal;

        meses.push({
          anyo: fecha.getFullYear(),
          mes: fecha.getMonth(),
          diasDisponibles,
          diasFestivos,
          dedicacionPosible,
          dedicacionProgramada,
          dedicacionProgramadaTotal,
          estructural: isNaN(estructural) ? "" : Math.round(estructural),
          comercial: isNaN(comercial) ? "" : Math.round(comercial),
          noIndicadaEstructural,
          noIndicadaComercial,
          dedicacionProgramadaTotalPc: Math.round((dedicacionProgramadaTotal / dedicacionPosible) * 100),
          dedicacionProgramadaPc: Math.round((dedicacionProgramada / dedicacionPosible) * 100),
          horasLibres: isNaN(horasLibres) ? Math.round(dedicacionPosible * (1 - pcEstructural)) : horasLibres,
        });
      }

      return meses;
    },
    mesesAnyo() {
      return this.meses.map((a) => `${a.anyo}-${a.mes + 1}`);
    },
    proyectosUnicos() {
      return [...new Set(this.rows.map((a) => a.id_projecte))];
    },
    proyectosUnicosOrdenados() {
      return JSON.parse(JSON.stringify(this.proyectosUnicos))
        .sort((a, b) => (parseInt(this.filtrarPrevision(b, "proyectos")) || 0) - (parseInt(this.filtrarPrevision(a, "proyectos")) || 0))
        .sort((a, b) => (this.rows.find(row => row.id_projecte == a)?.posicio || 0) - (this.rows.find(row => row.id_projecte == b)?.posicio || 0));
    },
    proyectosOrganizados() {
      let organizados = {};

      this.rows.forEach((a) => {
        if (!organizados[a.id_projecte]) organizados[a.id_projecte] = {};
        if (!organizados[a.id_projecte][a.any]) organizados[a.id_projecte][a.any] = {};

        organizados[a.id_projecte][a.any][a.mes] = a;
      });

      return organizados;
    },
    proyectosAnyadibles() {
      return this.proyectos.filter(a => !this.proyectosUnicos.includes(a.id));
    },
  },
  methods: {
    cambiarHorasGrupo(grupo, mes) {
      if (!this.editable) return;

      const params = { tipus: grupo, any: mes.anyo, mes: mes.mes + 1 };
      const valor = this.horasIndicadas[`${mes.anyo}${mes.mes}`][grupo];

      if (this.trabajadorEscogido) {
        params.id_treballador = this.trabajadorEscogido;
      }

      if (valor !== "") {
        this.$http.put(`api/hores_indicades`, {
          ...params,
          ...{
            hores: this.horasIndicadas[`${mes.anyo}${mes.mes}`][grupo],
          }
        })
          .then(response => {
            if (![200, 201].includes(response.status)) return;

            this.$toast.clear();
            this.$toast.open({ position: "top", message: this.OKmessage });
          })
      } else {
        this.$http.delete(`api/hores_indicades?${new URLSearchParams(params)}`)
          .then((response) => {
            if (response.status == 200) {
              this.$toast.clear();
              this.$toast.open({ position: "top", message: this.OKmessage });
            }
          });
      }
    },
    hasLimitOverpassed(projectId, anyo, mes) {
      const dateStr = this.proyectos.find(p => p.id == projectId)?.data_limit;

      if (!dateStr) return false;

      return `${anyo}-${String(mes).padStart(2, '0')}` >= dateStr.substring(0, 7);
    },
    getLimitDate(projectId) {
      const dateStr = this.proyectos.find(p => p.id == projectId)?.data_limit;

      if (!dateStr) return '';

      const parts = dateStr.split('-');
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];

      return `${day}/${month}/${year}`;
    },
    getData() {
      this.$http.get(`api/plans?${new URLSearchParams({ "trabajador": this.trabajadorEscogido })}`).then((response) => this.rows = response.data ? response.data.filter((a) => this.mesesAnyo.includes(`${a.any}-${a.mes}`)) : []);
      this.$http.get(`api/festius_personals?${new URLSearchParams({ "trabajador": this.trabajadorEscogido })}`).then((response) => (this.festivosPersonales = response.data ?? []));
      this.$http.get("api/festius_empresa").then((response) => (this.festivosEmpresa = response.data ?? []));
      this.$http.get(`api/treballadors/${this.trabajadorEscogido}`).then(response => this.jornada = response.data.jornada ?? 0);

      this.$http.get(`api/hores_indicades?${new URLSearchParams({ "trabajador": this.trabajadorEscogido })}`)
        .then(response => {
          const horas = {};

          response.data.forEach(a => {
            if (!horas[`${a.any}${a.mes - 1}`]) horas[`${a.any}${a.mes - 1}`] = {};

            horas[`${a.any}${a.mes - 1}`][a.tipus] = a.hores_indicades;
          });

          this.horasIndicadas = horas;
        });

      this.$http.get("api/projectes?facturables&order=cliente").then(response => this.proyectos = response.data);

      this.$http.get(`api/projectes?${new URLSearchParams({ "mesesNoFacturables": this.meses.length, "trabajador": this.trabajadorEscogido })}`).then(response => this.calculados = response.data);
    },
    getFestivo(mes) {
      return this.festivosPersonales.find((a) => a.mes == mes.mes + 1 && a.any == mes.anyo)?.dies ?? 0;
    },
    abrirModal(autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    filtrarProyecto(id, propiedad) {
      return this.rows.find((a) => a.id_projecte == id)[propiedad];
    },
    filtrarPrevision(id, tipo) {
      return this.previsiones[tipo].some((a) => a.id_projecte == id) ? Math.round(this.previsiones[tipo].find((a) => a.id_projecte == id).disponible) : null;
    },
    extraerTotalProyecto(id) {
      return this.rows.filter(a => a.id_projecte == id).reduce((a, b) => a + parseInt(b.hores_previstes?.length ?? b.hores_previstes ?? 0), 0) +
        (this.posiblesPrevistas[id] ? Object.keys(this.posiblesPrevistas[id]).reduce((a, b) => a + Object.values(this.posiblesPrevistas[id][b]).reduce((c, d) => c + parseInt(d?.length ?? d ?? 0), 0), 0) : 0);
    },
    extraerTotalAnyadido(id) {
      return this.horasAnyadidos.filter(a => a.proyecto == id).reduce((a, b) => a + parseInt(b.horasPrevistas ?? 0), 0);
    },
    filtrarHorasAnyadidos(proyecto, mesIndex) {
      return this.horasAnyadidos.find(a => a.proyecto == proyecto && a.mesIndex == mesIndex);
    },
    calcularPcPlan(mes, any, hores_previstes) {
      hores_previstes = hores_previstes ?? 0;

      return Math.round((hores_previstes / this.meses.find((b) => b.mes == mes && b.anyo == any)?.dedicacionPosible) * 100);
    },
    submitForm(e) {
      e.target.form.querySelector('[type="submit"]').click();
    },
    cambiarFestivos(mes) {
      if (!this.editable) return;
      if (!this.trabajadorEscogido) return;

      const index = this.festivosPersonales.findIndex((a) => a.mes == mes.mes + 1 && a.any == mes.anyo && a.id_treballador == this.trabajadorEscogido);
      const params = {
        any: mes.anyo,
        mes: mes.mes + 1,
      };

      params.id_treballador = this.trabajadorEscogido;

      if (mes.diasFestivos) {
        params.dies = mes.diasFestivos;

        this.$http.put(`api/festius_personals`, params)
          .then((response) => {
            if ([200, 201].includes(response.status)) {
              if (index == -1) {
                this.festivosPersonales.push(response.data);
              } else {
                this.$set(this.festivosPersonales[index], 'dies', mes.diasFestivos);
              }

              this.$toast.clear();
              this.$toast.open({ position: "top", message: this.OKmessage });
            }
          });
      } else {
        this.$http.delete(`api/festius_personals?${new URLSearchParams(params)}`)
          .then((response) => {
            if (response.status == 200) {
              this.festivosPersonales.splice(index, 1);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: this.OKmessage });
            }
          });
      }
    },
    cambiarHoras(plan) {
      if (!this.editable) return;

      const params = {
        any: plan.any,
        mes: plan.mes,
        id_projecte: plan.id_projecte,
      };

      if (this.trabajadorEscogido) {
        params.id_treballador = this.trabajadorEscogido;
      }

      if (parseInt(plan.hores_previstes)) {
        this.$http.put(`api/plans`, {
          ...params,
          ...{
            hores_previstes: plan.hores_previstes,
          }
        })
          .then((response) => {
            this.$toast.clear();
            this.$toast.open({ position: "top", message: this.OKmessage });
          });
      } else {
        this.$http.delete(`api/plans?${new URLSearchParams(params)}`)
          .then((response) => {
            if (response.status == 200) {
              this.$toast.clear();
              this.$toast.open({ position: "top", message: this.OKmessage });
            }
          });
      }
    },
    focus() {
      if (this.hayAltMode) {
        this.columnaActiva = document.activeElement.tabIndex;
      }
    },
    switchFocus(columna) {
      if (!this.editable) return;

      if (this.columnaActiva != columna) {
        this.columnaActiva = columna;
        this.hayAltMode = true;
      } else {
        this.hayAltMode = false;
      }
    },
    getProyectoValue(titulo, cliente) {
      return `${cliente.trim().replace(/ +(?= )/g, '')} → ${titulo.trim().replace(/ +(?= )/g, '')}`;
    },
    anyadirProyecto() {
      if (!this.editable) return;

      let proyecto;

      if (this.proyecto.length) {
        if (proyecto = this.proyectosAnyadibles.find(a => this.getProyectoValue(a.titol, a.cliente) == this.proyecto)) {
          this.rows.push({
            ...proyecto, ...{
              mes_any: `${this.meses[0].anyo}-${this.meses[0].mes + 1}-01`,
              any: this.meses[0].anyo,
              mes: this.meses[0].mes + 1,
              hores_previstes: null,
              posicio: this.rows.reduce((max, obj) => (obj.posicio > max ? obj.posicio : max), 0) + 1,
              id_projecte: proyecto.id,
              id_treballador: this.trabajadorEscogido,
            }
          });

          this.guardarOrden();

          this.proyecto = "";
        }
      }
    },
    guardarOrden() {
      if (!this.editable) return;

      this.loading.orden = true;

      this.$refs.ordenables?.forEach((a) => $(a).tooltip("hide"));

      this.$http
        .put("api/plans", { proyectos: this.proyectosUnicosOrdenados, id_treballador: this.trabajadorEscogido })
        .finally(() => this.loading.orden = false);
    },
  },
  created() {
    this.hayDatosSesion = localStorage.getItem("usuarioTrabajador") !== null;

    if (!this.hayDatosSesion) {
      this.$auth = false;

      return;
    }

    this.usuarioRol = localStorage.getItem("usuarioRol");
  },
  mounted() {
    if (!this.hayDatosSesion) return;

    this.getData();

    document.addEventListener("keydown", (e) => {
      switch (true) {
        case (e.code == "Escape" && this.hayAltMode):
          this.hayAltMode = false;
          break;
        case (e.ctrlKey && e.code == "Space"):
          this.hayAltMode = true;
          break;
      }
    });

    document.addEventListener("keyup", (e) => {
      if (e.code == "Tab" && this.hayAltMode) {
        this.columnaActiva = document.activeElement.tabIndex;
      }
    });
  },
  watch: {
    meses: {
      handler(value) {
        value.forEach((mes) => {
          if (!this.horasIndicadas[`${mes.anyo}${mes.mes}`]) this.$set(this.horasIndicadas, `${mes.anyo}${mes.mes}`, { estructural: "", comercial: "" });
        });
      },
      deep: true,
    },
    trabajadorEscogido() {
      this.getData();
    },
    hayAltMode(value) {
      this.$nextTick(() => this.columnaActiva = value ? document.activeElement.tabIndex : null);
    },
    proyectosUnicos(value) {
      this.$http.get(`api/hores_previstes?disponibles=${value.join()}`).then((response) => this.previsiones.proyectos = response.data);

      let posibles = {};

      this.proyectosUnicos.forEach((proyecto) => {
        this.meses.forEach(mes => {
          if (!this.proyectosOrganizados[proyecto][mes.anyo] || !this.proyectosOrganizados[proyecto][mes.anyo][mes.mes + 1]) {
            if (!posibles[proyecto]) posibles[proyecto] = {};
            if (!posibles[proyecto][mes.anyo]) posibles[proyecto][mes.anyo] = {};

            posibles[proyecto][mes.anyo][mes.mes + 1] = this.posiblesPrevistas?.[proyecto]?.[mes.anyo]?.[mes.mes + 1];
          }
        });
      });

      this.posiblesPrevistas = posibles;
    },
    ordenando(value) {
      if (value) return;

      this.guardarOrden();
    },
  },
};
</script>

<style lang="scss" scoped>
td,
tr {
  .position-sticky {
    left: 0;
  }
}

.input-number-2 {
  width: 41px
}

.collapsing {
  visibility: hidden;
}

.pointer-events-none {
  pointer-events: none;
}

.ghost {
  opacity: 0.5;
  background: var(--light);
}
</style>